import React, { useState } from 'react';
import { Dropdown, DropdownButton, Form, Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

import { useTranslation } from '../../../common/hooks/useTranslation';

interface ClonePositionButtonProps {
  onClone: (count: number) => void;
  disabled?: boolean;
}

export const ClonePositionButton: React.FC<ClonePositionButtonProps> = ({
  onClone,
  disabled,
}) => {
  const { t, tk } = useTranslation('fvsLng');
  const [showModal, setShowModal] = useState(false);
  const [cloneCount, setCloneCount] = useState<number | ''>('');

  const handleCloneMany = () => {
    onClone(Math.max(1, Math.min(999, Number(cloneCount))));
    setShowModal(false);
    setCloneCount('');
  };

  return (
    <>
      <DropdownButton
        title={t(tk.finance.clonePosition)}
        id="clone-position-dropdown"
        variant="outline-primary"
        disabled={disabled}
      >
        <Dropdown.Item onClick={() => onClone(1)} eventKey="1">
          {t(tk.finance.clonePositionOnce)}
        </Dropdown.Item>
        <Dropdown.Item onClick={() => setShowModal(true)} eventKey="2">
          {t(tk.finance.clonePositionMultiple)}
        </Dropdown.Item>
      </DropdownButton>
      <Modal
        show={showModal}
        centered
        onHide={() => setShowModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t(tk.finance.clonePositionMultiple)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>{t(tk.finance.clonePositionCount)}</Form.Label>
            <Form.Control
              type="number"
              min={1}
              max={999}
              value={cloneCount}
              onChange={e =>
                setCloneCount(
                  e.target.value === ''
                    ? ''
                    : Math.max(1, Math.min(999, Number(e.target.value))),
                )
              }
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => setShowModal(false)}
          >
            {t(tk.button.cancel)}
          </Button>
          <Button
            variant="outline-primary"
            onClick={handleCloneMany}
            disabled={cloneCount === '' || cloneCount < 1}
          >
            {t(tk.finance.clonePosition)}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
